import React from 'react';

import GoogleCalendarLogo from 'Shared/components/Logos/GoogleCalendarLogo';

import './MeetingsListItem.scss';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  id: number;
  name: string;
  attendees: Array<{
    fullName: string;
    email: string;
  }>;
  onClick: Function;
};

function MeetingsListItem({ id, name, attendees, onClick }: Props) {
  const attedeesList = attendees.map(({ fullName, email }) => fullName || email).join(', ');

  const handleItemClick = () => {
    const emails = attendees.map(({ email }) => email);
    onClick({ id, name, emails });
  };

  return (
    <div className="meetings-list-item d-flex p-2 cursor-pointer text-break" onClick={handleItemClick}>
      <div className="d-flex flex-column mr-3">
        <div className="d-flex align-items-center">
          <GoogleCalendarLogo width="16" className="mr-2" />
          <div>{name}</div>
        </div>
        <div className="meetings-list-item-attendees ml-4">Attendees: {attedeesList}</div>
      </div>
      <div className="ml-auto d-flex align-items-center">
        <span className="meetings-list-item-icon">
          <WpIcon name="plus-circle" />
        </span>
      </div>
    </div>
  );
}

export default MeetingsListItem;
